/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { useInit } from '../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import {
    addOption,
    InputPassword,
    SelectOption,
    TextareaField
} from '../../../../utils/InputField';

function ModalAgencyChangeCurrency({ onReload }) {
    const { currencyList } = useInit();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { modalData, closeModal, setMessage } = useTemplate();
    const { put } = useApi();

    const [formData, setFormData] = useState({
        AgencyId: modalData?.agencyId || '',
        Currency: modalData?.currency || '',
        Note: ''
    });

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleOnSubmit = (e) => {
        setLoading(true);
        e?.preventDefault();
        put(`api/agency/${formData?.AgencyId}/currency-change`, formData)
            .then(({ error, referenceName, message }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                onReload();
                closeModal();
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleOnSubmit} className="flex flex-col gap-3 w-full">
            <p className="text-sm font-normal">
                Are you sure you want to change the agency currency?
            </p>
            <SelectOption
                name="Currency"
                label="Currency"
                placeholder="Currency"
                formData={formData}
                onChange={handleOnChange}
                options={currencyList?.map((d) => addOption(d?.key, d?.key, d?.key))}
                className="bg-white"
                required
            />
            <TextareaField
                name="Note"
                label="Note"
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleOnChange}
                className="h-20 *:resize-none"
                required
            />

            <InputPassword
                name="Password"
                label="Your Password"
                formData={formData}
                onChange={handleOnChange}
                placeholder="Enter your password"
                required
            />
            {/* <p className="text-error text-xs text-left ">These field are required.</p> */}
            {/* Show warning for change currency */}
            <p className="text-error text-sm text-left ">
                Warning: Changing the currency will affect all future transactions. Existing
                transactions aren't affected.
            </p>
            <div className=" w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModalAgencyChangeCurrency;
